import { app } from '../../../bootstrap/core';
import { headComponent } from './head.component';

app.component('fdHead', headComponent);
